import { NgxMatColorPickerModule } from '@angular-material-components/color-picker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AddReportButtonComponent } from '../../add-report-button/add-report-button.component';
import { AddressFormComponent } from '../../address-form/address-form.component';
import { BurgerButtonWrapperComponent } from '../../burger-button-wrapper/burger-button-wrapper.component';
import { TextareaModule } from '../../components/templates/textarea/textarea.module';
import { CustomFormsModule } from '../../custom-forms-module/custom-forms.module';
import { DaveDoubleIconModule } from '../../dave-double-icon/dave-double-icon.module';
import { DaveEventListEntryModule } from '../../dave-event-list-entry/dave-event-list-entry.module';
import { DaveLoadingModule } from '../../dave-loading/dave-loading.module';
import { FilenameInputComponent } from "../../filename-input/filename-input.component";
import { HintIconComponent } from '../../hint-icon/hint-icon.component';
import { MatColorPickerToggleComponent } from '../../mat-color-picker-toggle/mat-color-picker-toggle.component';
import { MatColorPreviewComponent } from '../../mat-color-preview/mat-color-preview.component';
import { PersonListEntryComponent } from '../../person-list-entry/person-list-entry.component';
import { TopButtonWrapperComponent } from '../../top-button-wrapper/top-button-wrapper.component';
import { TravelZoneSelectComponent } from '../../travel-zone/components/travel-zone-select/travel-zone-select.component';
import { AppButtonModule } from '../app-button-module/app-button.module';
import { AppFilterModule } from '../app-filter-module/app-filter.module';
import { IconPipeModule } from '../icon-pipe/icon-pipe.module';
import { SelectSearchModule } from '../select-search/select-search.module';
import {
DetailListTemplateComponent,
ProfileTemplateDetailDialogComponent
} from './components/detail-views/detail-list-template/detail-list-template.component';
import {
DetailViewBeforeButtonsDirective
} from './components/detail-views/detail-view-template/detail-view-before-butons.directive';
import { DetailViewButtonsDirective } from './components/detail-views/detail-view-template/detail-view-buttons.directive';
import { DetailViewLeftContentDirective } from './components/detail-views/detail-view-template/detail-view-left-content.directive';
import { DetailViewRightContentDirective } from './components/detail-views/detail-view-template/detail-view-right-content.directive';
import { DetailViewTemplateComponent } from './components/detail-views/detail-view-template/detail-view-template.component';
import { DetailViewTopContentDirective } from './components/detail-views/detail-view-template/detail-view-top-content.directive';
import { ProfileTemplateComponent } from './components/detail-views/profile-template/profile-template.component';
import { InfoDialogComponent } from './components/dialogs/info-dialog/info-dialog.component';
import { SupportDialogComponent } from './components/dialogs/support-dialog/support-dialog.component';
import { HistoryBookmarksComponent } from './components/history-bookmarks/history-bookmarks.component';
import { ChipsComponent } from './components/templates/chips/chips.component';
import { DatepickerComponent } from './components/templates/datepicker/datepicker.component';
import { IconSelectDialogComponent } from './components/templates/event-types-selector-card/icon-select-dialog/icon-select-dialog.component';
import { ImageUploadComponent } from './components/templates/image-upload/image-upload.component';
import { ListLayoutWithRoutingTabDirective } from './components/templates/list-layout-with-routing/list-layout-with-routing-tab.directive';
import { ListLayoutWithRoutingComponent } from './components/templates/list-layout-with-routing/list-layout-with-routing.component';
import { NumberfieldComponent } from './components/templates/numberfield/numberfield.component';
import { RatingComponent } from './components/templates/rating/rating.component';
import { TextfieldComponent } from './components/templates/textfield/textfield.component';
import { ClickableMatRowDirective } from './directives/clickable-mat-row.directive';
import { PipesModule } from './pipes/pipes.module';
import { BreakpointObserverService } from './services/breakpoint-observer.service';
import {
  SelectSearchPagedOptionsComponent
} from '../select-search/components/select-search-paged-options/select-search-paged-options.component';
import { MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import { MatPaginatorWrapperComponent } from '../../mat-paginator-wrapper/mat-paginator-wrapper.component';

@NgModule({
    declarations: [
        ClickableMatRowDirective,
        ListLayoutWithRoutingComponent,
        HistoryBookmarksComponent,
        ListLayoutWithRoutingTabDirective,
        DatepickerComponent,
        RatingComponent,
        ImageUploadComponent,
        TextfieldComponent,
        DetailViewTemplateComponent,
        ProfileTemplateComponent,
        DetailViewLeftContentDirective,
        DetailViewTopContentDirective,
        DetailViewRightContentDirective,
        DetailListTemplateComponent,
        ProfileTemplateDetailDialogComponent,
        NumberfieldComponent,
        DetailViewBeforeButtonsDirective,
        DetailViewButtonsDirective,
        IconSelectDialogComponent,
        ChipsComponent,
        InfoDialogComponent,
        SupportDialogComponent,
    ],
    imports: [
        IconPipeModule,
        MatCheckboxModule,
        CommonModule,
        MatTabsModule,
        RouterModule,
        MatDatepickerModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        FontAwesomeModule,
        MatTooltipModule,
        SimplebarAngularModule,
        MatTableModule,
        MatDividerModule,
        MatListModule,
        PipesModule,
        MatSortModule,
        MatInputModule,
        MatButtonModule,
        AppButtonModule,
        MatSelectModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        SelectSearchModule,
        MatSlideToggleModule,
        DaveDoubleIconModule,
        MatSidenavModule,
        AppFilterModule,
        TextareaModule,
        ScrollingModule,
        TableVirtualScrollModule,
        // TableVirtualScrollModule,
        MatMenuModule,
        DaveLoadingModule,
        MatExpansionModule,
        DaveEventListEntryModule,
        BurgerButtonWrapperComponent,
        MatBadgeModule,
        CustomFormsModule,
        AddReportButtonComponent,
        NgClickOutsideDirective,
        NgxMatColorPickerModule,
        MatColorPreviewComponent,
        MatColorPickerToggleComponent,
        PersonListEntryComponent,
        FilenameInputComponent,
        AddressFormComponent,
        FormsModule,
        TravelZoneSelectComponent,
        TopButtonWrapperComponent,
        HintIconComponent,
        MatLegacyRadioModule,
        SelectSearchPagedOptionsComponent,
        MatLegacyPaginatorModule,
        MatPaginatorWrapperComponent,
    ],
    exports: [
        ListLayoutWithRoutingComponent,
        HistoryBookmarksComponent,
        ListLayoutWithRoutingTabDirective,
        DatepickerComponent,
        RatingComponent,
        ImageUploadComponent,
        TextfieldComponent,
        DetailViewTemplateComponent,
        ProfileTemplateComponent,
        DetailViewLeftContentDirective,
        DetailViewRightContentDirective,
        DetailListTemplateComponent,
        NumberfieldComponent,
        DetailViewBeforeButtonsDirective,
        DetailViewButtonsDirective,
        ClickableMatRowDirective,
        IconSelectDialogComponent,
        ChipsComponent,
        InfoDialogComponent,
        DetailViewTopContentDirective,
    ],
    providers: [BreakpointObserverService],
})
export class DaveSharedComponentsModule {}
